import React from 'react'
import { Modal } from 'react-bootstrap'
import DisplayStar from '../Componants/DisplayStar'
import { useQuery } from '@tanstack/react-query';
import { getRequest } from '../services/apiMethods';
import { capitalizeWords, filterTheArray } from '../utils/HelperFunctions';
import { useNavigate } from 'react-router-dom';

const GiveReviewModal = ({review, handleReviewClose , leadID}) => {
    const Navigate = useNavigate()
    const {
        data: CustomerEnquiriesDetailData,
        error,
        isLoading,
        refetch,
      } = useQuery({
        queryKey: ["CustomerEnquiriesDetail"],
        queryFn: () => getRequest(`/lead/info?id=${leadID}`),
        enabled: !!leadID,
      });
    
      const enquiryDetail = CustomerEnquiriesDetailData?.data;

      console.log("enquiryDetailenquiryDetailenquiryDetail",enquiryDetail)

      const allVendors = [
        ...(enquiryDetail?.vendors || []),
        ...(enquiryDetail?.premiumvendors || []),
      ];
      
      const mergedArray = allVendors.reduce((acc, current) => {
        if (!acc.some(item => item._id === current._id)) {
          acc.push(current);
        }
        return acc;
      }, []);



  return (
    <Modal size="lg" show={review} onHide={handleReviewClose}>
      <Modal.Body>
        <div>
          <div className="electrician-profile-pop p-5">
            <h2 className="justify-content-between text-center ">
              <strong> Work Complete! </strong>
            </h2>
            <p className="electrician-ds text-center">
              We're glad to hear you had work completed by a SparkPro
              Electrician! Please confirm which electrician carried out the work
              from the list below and leave a review to share your experience.
            </p>

            <div className="trusted-businesses-cards">
              {Array.isArray(mergedArray) && mergedArray.length > 0 ? (
                <ul>
                  {mergedArray.map((ele, index) => (
                    <li key={index}>
                      <div className="businesses-cards p-3">
                        <div>
                          <div
                            className={
                              ele?.subscription?.plan === "Premium"
                                ? "businesses-img"
                                : "withoutPrime-businesses-img"
                            }
                          >
                            {ele?.image ? (
                              <img
                                src={ele.image}
                                className={
                                  ele?.subscription?.plan === "Premium"
                                    ? "prime"
                                    : ""
                                }
                                alt="Vendor"
                              />
                            ) : (
                              <div
                                className={
                                  ele?.subscription?.plan === "Premium"
                                    ? "enquiryDetail-custom-circle prime"
                                    : "enquiryDetail-custom-circle"
                                }
                              >
                                <span>
                                  {ele?.bussinessName?.toUpperCase()?.at(0) ||
                                    "N"}
                                </span>
                              </div>
                            )}

                            {ele?.verificationStatus === "Approved" && (
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27"
                                  height="27"
                                  viewBox="0 0 27 27"
                                  fill="none"
                                >
                                  <rect
                                    width="25"
                                    height="25"
                                    rx="12.5"
                                    transform="matrix(-1 0 0 1 26 1)"
                                    fill="#337FE0"
                                    stroke="white"
                                    strokeWidth="2"
                                  />
                                  <path
                                    d="M20.0001 10L11.7066 16.8581L8 13.2486"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            )}

                            {ele?.subscription?.plan === "Premium" && (
                              <span className="prime-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27"
                                  height="27"
                                  viewBox="0 0 27 27"
                                  fill="none"
                                >
                                  <rect
                                    width="25"
                                    height="25"
                                    rx="12.5"
                                    transform="matrix(-1 0 0 1 26 1)"
                                    fill="#FFC130"
                                    stroke="white"
                                    strokeWidth="2"
                                  />
                                  <path
                                    d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                            )}
                          </div>

                          <div className="view-your-resp">
                            {ele?.bussinessName && (
                              <h3>{capitalizeWords(ele.bussinessName)}</h3>
                            )}
                            <span
                              className="work-review"
                              style={{ display: "flex" }}
                            >
                              <span className="mt-2 review-rating">
                                ({ele?.review} reviews)
                              </span>
                              <DisplayStar
                                rating={
                                  ele?.rating ? Math.floor(ele.rating) : 0
                                }
                                size={22}
                              />
                            </span>
                          </div>
                        </div>
                        <button
                          className="confirm-rating"
                          onClick={() =>
                            Navigate(`/leave-review?vendorId=${ele?._id}&leadId=${leadID}`)
                          }
                        >
                          Confirm
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="empity-responses">
                  Responses from SparkPro members will show here.
                  <br />
                  We’ll notify you when someone responds to your enquiry.
                </p>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default GiveReviewModal
